var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('error-dialog',{attrs:{"value":_vm.flag,"props":{ persistent: true, 'max-width': '50%' }},on:{"ok-button-click":_vm.onClickOk},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }